var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddleCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 519,
    viewBox: "0 0 222 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 259.5,
    cy: 259.5,
    r: 259.5,
    fill: "url(#paint0_radial_612_4594)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_612_4594",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(259.5 259.5) rotate(90) scale(259.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005C7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C7B",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleCircle);
export default __webpack_public_path__ + "static/media/MiddleCircle.5369d1cf14dd8d936b9d028eb96bdf0a.svg";
export { ForwardRef as ReactComponent };